import { AlingTableButton, fileUpload } from "./utils";
import { settings } from "app";

export const important = true;

export const joditCssClasses = {
  root: "jodit-wysiwyg",
  urlModalInput: "jodit-ui-input__input",
};

const buttonsConfig = {
  alignTable: {
    name: `aling table`,
    icon: "table",
    list: {
      ["auto 0 0 0"]: "table left",
      ["0 auto"]: "table center",
      ["0 0 0 auto"]: "table right",
    },
  },

  uploadFile: {
    name: "upload file",
    icon: "file",
    tooltip: "upload file",
    exec: (editor, _current, _control) => {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();

      input.onchange = async function () {
        const file = input.files[0];

        if (!file) {
          return;
        }

        const upload = await fileUpload(file);

        if (upload.ok) {
          editor.execCommand("openlinkdialog");

          const path = upload.url.replace("/api/", "");

          const fullPath = `${settings.cmsApi}/${path}`;

          const urlInput = document.querySelector(`.${joditCssClasses.urlModalInput}`);

          urlInput.value = fullPath;

          return;
        } else {
          alert(upload.error);
          return;
        }
      };
    },
  },
};

const alingTableButton = new AlingTableButton(buttonsConfig.alignTable);

const UploadFileButton = buttonsConfig.uploadFile;

export const config = {
  readonly: false,
  width: "83vw",
  removeButtons: ["file", "table"],
  extraButtons: [UploadFileButton, alingTableButton],
};
